import * as logisticTasks from './logisticTasks';

const reducers = {
  ...logisticTasks,
};

export default reducers;
